/* PartyDesign: cart field + Shopify server validation through SMART Checkout Rules. */
(() => {
  'use strict';
  if (customElements.get('pd-contact-phone')) return;
  const key = 'Телефон за връзка';
  let draft;
  let saved;
  let saveQueue = Promise.resolve();
  let pending = false;
  let timer;
  const replay = new WeakSet();
  const fields = () => Array.from(document.querySelectorAll('pd-contact-phone'));
  const valid = value => /^\+?[\d\s().-]+$/.test(value) && /^\d{7,15}$/.test(value.replace(/\D/g, ''));
  const root = () => window.Shopify?.routes?.root || '/';
  function status(text, invalid = false) {
    fields().forEach(field => {
      field.querySelector('[data-phone-status]').textContent = text;
      field.input.setAttribute('aria-invalid', String(invalid));
    });
  }
  function persist(value) {
    const cleaned = value.trim();
    // Erase stale phone data on invalid/empty input and obsolete delivery labels.
    const valueToSave = valid(cleaned) ? cleaned : '';
    const operation = saveQueue.catch(() => {}).then(async () => {
      const response = await fetch(root() + 'cart/update.js', {
        method: 'POST', headers: {'Content-Type':'application/json', Accept:'application/json'},
        body: JSON.stringify({attributes:{[key]:valueToSave, 'Order Type':''}})
      });
      if (!response.ok) throw new Error('Phone update failed');
      const cart = await response.json();
      if ((cart.attributes?.[key] || '') !== valueToSave) throw new Error('Phone was not persisted');
      saved = valueToSave;
    });
    saveQueue = operation;
    return operation;
  }
  class ContactPhone extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      if (!this.input || this.bound) return;
      this.bound = true;
      if (draft === undefined) draft = this.input.value;
      this.input.value = draft;
      this.input.addEventListener('input', () => {
        draft = this.input.value;
        fields().forEach(field => { if(field !== this && field.input) field.input.value = draft; });
        this.input.setCustomValidity('');
        status('');
        clearTimeout(timer);
        timer = setTimeout(() => persist(draft).catch(() => status(this.dataset.saveError)), 350);
      });
      this.input.addEventListener('invalid', () => {
        status(this.dataset.invalid, true);
        this.input.setCustomValidity(this.dataset.invalid);
      });
    }
  }
  customElements.define('pd-contact-phone', ContactPhone);
  function findField(control) {
    return fields().find(field => field.input?.form === control.form) || fields().find(field => field.offsetParent !== null);
  }
  async function intercept(event, control) {
    if (replay.has(control)) { replay.delete(control); return; }
    const field = findField(control);
    if (!field) {
      event.preventDefault(); event.stopImmediatePropagation();
      location.assign(root() + 'cart#pd-contact-phone-cart');
      return;
    }
    const value = field.input.value.trim();
    // The calendar re-submits after its own date/slot validation.
    if (event.type === 'submit' && !pending && valid(value) && saved === value) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (pending) return;
    clearTimeout(timer);
    if (!valid(value)) {
      status(field.dataset.invalid, true);
      field.input.setCustomValidity(field.dataset.invalid);
      field.input.focus(); field.input.reportValidity();
      persist('').catch(() => status(field.dataset.saveError, true));
      return;
    }
    pending = true;
    status(field.dataset.saving);
    try {
      await persist(value);
      status('');
      field.input.setCustomValidity('');
      pending = false;
      replay.add(control);
      if (event.type === 'click') control.click();
      else if (event.submitter) event.target.requestSubmit(event.submitter);
      else event.target.requestSubmit();
    } catch (error) {
      status(field.dataset.saveError, true); field.input.focus();
    } finally { pending = false; }
  }
  // Run before app document handlers, then replay to preserve date validation.
  window.addEventListener('click', event => {
    const control = event.target.closest?.('[name="checkout"],a[href="/checkout"],a[href$="/checkout"]');
    if (control) intercept(event, control);
  }, true);
  window.addEventListener('submit', event => {
    const control = event.submitter;
    if (control?.name === 'checkout') intercept(event, control);
  }, true);
})();
